
import View from 'ln/view/View';
import VideoPlayer from '../VideoPlayer';

class PlayButton extends View{

    constructor( public player:VideoPlayer ){
        super();

        this.defaultTemplate = 'lv.video-play'

        //register on video to toggle pause/play
        this.player.playing.add( this.toggleButton, this );
        this.player.pausing.add( this.toggleButton, this );

    }

    public init(){
        this.node.click.add( this.togglePlayer, this );
    }

    private togglePlayer(){
        ( this.player.paused ) ? this.player.play() : this.player.pause();
    }

    private toggleButton(){
        this.node.js( 'play-pause' ).toggleClass( '-toggled' );
    }

}

export default PlayButton;